import { Fragment } from "react";
import TableComponent from "../../components/Tables/TableComponent";

const TableContainer = ({ tableConfig }) => {
  const columns = tableConfig.headers
    .map((header) => (header.columnName ? header.columnName : null))
    .filter((columnName) => columnName !== null);
  const checkable = tableConfig.checkable || false;
  return (
    <Fragment>
      <TableComponent tableConfig={tableConfig} columns={columns} checkable={checkable} />
    </Fragment>
  );
};

export default TableContainer;
